export class AuthCredentials {
  login = '';
  password = '';
  md5Password = '';
  application: string = null;
  crowdId: number = null;

  constructor() {}
}
